import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';
import RouteSeo from './seo/RouteSeo';

// Часто посещаемые страницы кабинета и юр. документы, лениво,
// чтобы не утяжелять первый бандл лендинга.
const Signup = lazy(() => import('./pages/Signup'));
const Login = lazy(() => import('./pages/Login'));
const Cabinet = lazy(() => import('./pages/Cabinet'));
const Support = lazy(() => import('./pages/Support'));
const Contacts = lazy(() => import('./pages/Contacts'));
const Changelog = lazy(() => import('./pages/Changelog'));
const Roadmap = lazy(() => import('./pages/Roadmap'));
const Downloads = lazy(() => import('./pages/Downloads'));
const Docs = lazy(() => import('./pages/Docs'));
const DocArticle = lazy(() => import('./pages/DocArticle'));
const Suppliers = lazy(() => import('./pages/Suppliers'));
const Wholesalers = lazy(() => import('./pages/Wholesalers'));
const OpenInApp = lazy(() => import('./pages/OpenInApp'));
const NotFound = lazy(() => import('./pages/NotFound'));

const Offer = lazy(() => import('./pages/Offer'));
const Privacy = lazy(() => import('./pages/Privacy'));
const DataProcessing = lazy(() => import('./pages/DataProcessing'));
const Consent = lazy(() => import('./pages/legal/Consent'));
const CookiesPolicy = lazy(() => import('./pages/legal/CookiesPolicy'));
const Return = lazy(() => import('./pages/legal/Return'));
const Security = lazy(() => import('./pages/legal/Security'));

export default function App() {
  return (
    <>
      <ScrollToTop />
      {/* title/description/canonical/OG/JSON-LD маршрута, см. src/seo/pages.ts */}
      <RouteSeo />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cabinet" element={<Cabinet />} />
          {/* Раньше /cabinet/billing и /coming-soon были заглушками «скоро».
              Сейчас тариф и вход в админку живут в /cabinet (реальные данные
              подписки + SSO в admin.resstro.ru), поэтому редиректим туда. */}
          <Route path="/cabinet/billing" element={<Navigate to="/cabinet" replace />} />
          <Route path="/coming-soon" element={<Navigate to="/cabinet" replace />} />
          <Route path="/support" element={<Support />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/downloads" element={<Downloads />} />
          {/* Документация: ссылка только в футере. Каждая статья записана в src/seo/pages.ts. */}
          <Route path="/docs" element={<Docs />} />
          <Route path="/docs/:slug" element={<DocArticle />} />
          <Route path="/suppliers" element={<Suppliers />} />
          <Route path="/wholesalers" element={<Wholesalers />} />
          {/* Кабинеты поставщика и оптовика вынесены в отдельные приложения (PWA) -
              корневые папки /supplier и /wholesaler. */}

          {/* Universal link гостевого приложения People (AASA в public/.well-known).
              /venues/:id и /establishments/:id, те же адреса, что понимает DeepLink в iOS. */}
          <Route path="/v/:id" element={<OpenInApp />} />
          <Route path="/venues/:id" element={<OpenInApp />} />
          <Route path="/establishments/:id" element={<OpenInApp />} />
          <Route path="/v" element={<Navigate to="/" replace />} />

          <Route path="/legal/offer" element={<Offer />} />
          <Route path="/legal/privacy" element={<Privacy />} />
          <Route path="/legal/consent" element={<Consent />} />
          <Route path="/legal/cookies" element={<CookiesPolicy />} />
          <Route path="/legal/return" element={<Return />} />
          <Route path="/legal/security" element={<Security />} />
          {/* Совместимость со старым URL */}
          <Route path="/legal/data" element={<DataProcessing />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <CookieBanner />
    </>
  );
}

function RouteFallback() {
  // Минимальный плейсхолдер, не сбрасывает разметку, не дёргает layout.
  return <div style={{ minHeight: '100vh', background: '#fafaf8' }} aria-hidden />;
}
